import { AnimatePresence, motion } from "framer-motion";
import "../App.css";

type ConfirmDialogProps = {
  message: string;
  onResolve: (result: boolean) => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ message, onResolve }) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="confirm-backdrop"
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="confirm-box"
        >
          <p className="confirm-message">{message}</p>
          <div className="confirm-buttons">
            <button className="btn btn-yes" onClick={() => onResolve(true)}>
              Yes
            </button>
            <button className="btn btn-no" onClick={() => onResolve(false)}>
              No
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConfirmDialog;
